module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j9xDU"))).then(() => parcelRequire('1aFzU'));